module.exports = __webpack_public_path__ + "9e59eb153916862986f6dc7d35644a77.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/diamond/images/cutScale/very-good.png
// module id = 847
// module chunks = 0